import { render } from "./Feedback.vue?vue&type=template&id=ca139702&scoped=true&lang=pug"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=ca139702&lang=scss"
import "./Feedback.vue?vue&type=style&index=1&id=ca139702&lang=scss&scoped=true"
import "./Feedback.vue?vue&type=style&index=2&id=ca139702&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca139702"]])

export default __exports__